export default "__VITE_ASSET__98b122f3__"